module.exports = __webpack_public_path__ + "static/media/ic_pin_magenta.d6e07ff9.webp";


//////////////////
// WEBPACK FOOTER
// ./assets/img/ic_pin_magenta.webp
// module id = 195
// module chunks = 1